import {lazy} from 'react';

const PageNotFound = lazy(() => import('./PageNotFound'));

export default PageNotFound;
